import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { DatePickerItem } from 'Components/form'
import SaleChart from './SaleChart'
import { cloneDeep } from 'lodash'
import { PaymentStatReq } from 'Store/dashboard/types'
import { selectCurrentUser } from 'Store/user/selector'
import { selectPaymentStatDashboard } from 'Store/dashboard/selector'
import { currentDate, formatDateWithoutTime, toDateQuery } from 'helpers/format'
import { paymentStatDashboardAPI } from 'Store/dashboard/api'

type Props = {} & ReduxProps

const TimeSale: React.FunctionComponent<Props> = props => {
  const dispatch = useDispatch()
  const { currentUser, paymentStat } = props
  const initFilter = {
    date: currentDate(),
  }

  const [filter, setFilter] = useState(cloneDeep(initFilter))

  const handleChangeDate = (date: string) => {
    setFilter({
      ...filter,
      date: date,
    })
  }

  const onGetData = (): void => {
    const req: PaymentStatReq = {
      mid: currentUser?.activeMerchant?.id || 0,
      start_date: toDateQuery(filter.date),
      end_date: toDateQuery(filter.date),
    }

    dispatch(paymentStatDashboardAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetData()
    }
  }, [filter.date])

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col>
            <BoxTitle>
              ช่วงเวลาขายดี <Label>{`(ประจำวันที่ ${formatDateWithoutTime(filter.date)})`} </Label>
            </BoxTitle>
          </Col>
          <Col md={6} xs={24}>
            <DatePickerItem
              placeHolder={'เลือกวันที่'}
              onChange={handleChangeDate}
              date={filter.date}
              allowClear={false}
            />
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24}>
        <BoxWrapper>
          <Unit>ยอดขาย (บาท)</Unit>
          <Row justify="start" align="bottom">
            <Col span={22}>
              <SaleChart paymentStat={paymentStat} />
            </Col>
            <Col span={2}>
              <Unit>ช่วงเวลา (นาฬิกา)</Unit>
            </Col>
          </Row>
        </BoxWrapper>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 20px;
  border-color: transparent;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const Label = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const Unit = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  padding-bottom: 10px;
`

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    currentUser: selectCurrentUser(state),
    paymentStat: selectPaymentStatDashboard(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(TimeSale)
